import lawService from "./customAjax"
const createBusiness=async (companyInfo,finorIgn,contactId,fieldAgentId,setLoading)=>{
    try{
   const companyResponse= await lawService.createCompanyContact(companyInfo,finorIgn)
    const companyContactId=companyResponse.data.data.id
    const companyMatterResponst= await lawService.createCompanyMatter(companyContactId,contactId,finorIgn,fieldAgentId)
    console.log("COMP RESPONSE",companyMatterResponst.data.data.id)
    return companyMatterResponst.data.data.id
    }
    catch{
        setLoading((ps) => {
                let pd = {...ps}
                pd.isError=true
                return pd;
              });
    }
}
//845156
export default createBusiness